module.exports = __webpack_public_path__ + "static/media/lily_icon.e6293ff8.png";